<template>
  <div class="change-password-container">
    <v-container class="fill-height pa-0" fluid>
      <v-row align="center" justify="center" no-gutters>
        <v-col cols="12" sm="8" md="5" lg="4">
          <v-card class="elevation-12 mx-5">
            <v-card-title class="justify-center">
              Cambiar contraseña
            </v-card-title>
            <v-card-subtitle class="text-center">
              Debes establecer una nueva contraseña para continuar.
            </v-card-subtitle>
            <v-card-text class="pa-6">
              <v-alert v-if="error" type="error" dense outlined class="mb-4">{{ error }}</v-alert>
              <v-form ref="form" v-model="valid" @submit.prevent="submit">
                <v-text-field
                  v-if="!mustChangePassword"
                  v-model="currentPassword"
                  label="Contraseña actual"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  outlined
                  dense
                  class="mb-3"
                />
                <v-text-field
                  v-model="newPassword"
                  label="Nueva contraseña"
                  :type="showPassword ? 'text' : 'password'"
                  :rules="[v => !!v || 'Requerida', v => (v && v.length >= 8) || 'Mínimo 8 caracteres']"
                  outlined
                  dense
                  class="mb-3"
                />
                <v-text-field
                  v-model="confirmPassword"
                  label="Confirmar contraseña"
                  :type="showPassword ? 'text' : 'password'"
                  :rules="[v => v === newPassword || 'Las contraseñas no coinciden']"
                  outlined
                  dense
                  class="mb-4"
                />
                <v-btn color="primary" type="submit" block :loading="loading" :disabled="!valid">
                  Guardar contraseña
                </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from '@/plugins/axios';

export default {
  name: 'ChangePasswordView',
  data() {
    return {
      valid: false,
      loading: false,
      error: '',
      showPassword: false,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      mustChangePassword: localStorage.getItem('mustChangePassword') === 'true',
    };
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      this.error = '';
      try {
        await axios.post('/api/auth/change-password', {
          currentPassword: this.mustChangePassword ? undefined : this.currentPassword,
          newPassword: this.newPassword,
        });
        localStorage.setItem('mustChangePassword', 'false');
        const role = localStorage.getItem('userRole');
        if (role === 'super_admin') {
          this.$router.replace('/platform/dashboard');
        } else {
          this.$router.replace('/dashboard');
        }
      } catch (err) {
        this.error = err.response?.data?.mensaje || 'No se pudo cambiar la contraseña';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.change-password-container {
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  align-items: center;
}
</style>
